import { message } from "antd";
import zhCN from "@/locale/zh-CN.messages";
import esES from "@/locale/es-ES.messages";
import enUS from "@/locale/en-US.messages";

const FetchHandler = async (fetchName, params, flag) => {
  try {
    const localeValue = window.sessionStorage.getItem("locale");
    let messageInfo = null;
    if (localeValue === "zh") {
      messageInfo = zhCN.fetchHandler;
    } else if (localeValue === "es") {
      messageInfo = esES.fetchHandler;
    } else {
      messageInfo = enUS.fetchHandler;
    }
    const resultData = await fetchName(params, localeValue);

    if (resultData.data) {
      if (resultData.data.code.toString() === "200" || resultData.data.code.toString() === "304") {
        if (resultData.data.text) {
          message.success(resultData.data.text, 1);
        }
        return {
          code: "success",
          data: resultData.data.data,
          pageLimit: resultData.data.pageLimit,
        };
      } else {
        // 状态码异常
        /* temp */
        if (resultData.data.text === messageInfo.msg1) {
          return;
        }
        if (flag && resultData.data.text === messageInfo.msg2) {
          return;
        }
        if (resultData.data.text) {
          message.warning(resultData.data.text, 1);
        }
        return {
          code: "no_data",
        };
      }
    } else {
      // 接口返回异常
      if (resultData.data.text) {
        message.warning(resultData.data.text, 1);
      }
      return {
        code: "error",
        text: resultData.data.text,
      };
    }
  } catch (e) {
    console.log("xxxxxxxxxx", e);
    // 请求失败
    message.warning(e.message);
    return {
      code: "fail",
    };
  }
};

export default FetchHandler;



// WEBPACK FOOTER //
// ./src/AntD/fetch/fetchHandler.js